<template>
  <div class="box">
    <el-form ref="form" label-width="280px">
      <el-divider>Info</el-divider>
      <el-form-item label="Type">
        <div class="text-details">
          {{ studentParticular.levelApplyingFor | levelApplyingFor }}
        </div>
      </el-form-item>
      <el-divider>Student Paticulars</el-divider>
      <el-form-item label="Registration no.">
        <div class="text-details">
          {{ formLabelAlign.registrationNo }}
        </div>
      </el-form-item>
      <el-form-item label="Name Of Student (中)">
        <el-input
          :disabled="true"
          v-model="studentParticular.chineseName"
        ></el-input>
      </el-form-item>
      <el-form-item label="Name Of Student (Eng)">
        <el-input
          :disabled="true"
          v-model="studentParticular.englishName"
        ></el-input>
      </el-form-item>
      <el-form-item label="Date Of Birth (dd/mm/yyyy)">
        <div class="text-details">
          {{ studentParticular.dateOfBirth | applicationFormatDate }}
        </div>
      </el-form-item>
      <el-form-item label="Age">
        <div class="text-details">{{ age }}</div>
     
      </el-form-item>
      <el-form-item label="Sex">
        <div class="text-details">{{ studentParticular.gender | setSex }}</div>
       
      </el-form-item>
      <el-form-item label="Place Of Birth">
        <div class="text-details">{{ studentParticular.placeOfBirth }}</div>
       
      </el-form-item>
      <el-form-item label="Nationality">
        <div class="text-details">{{ studentParticular.nationality }}</div>
       
      </el-form-item>
      <el-form-item label="Religion">
        <div class="text-details">{{ studentParticular.religion }}</div>
       
      </el-form-item>
      <el-form-item label="Place Of BirthBirth Cert / Passport No.">
        <div class="text-details">{{ identityDocument }}</div>
      </el-form-item>
      <el-form-item label="Chi Address">
        <div class="text-details">{{ address }}</div>
       
      </el-form-item>
      <el-form-item label="Eng Address">
        <div class="text-details">{{ addressEn }}</div>
        
      </el-form-item>
      <el-form-item label="Home Phone">
        <el-input
          :disabled="true"
          v-model="studentParticular.contactNo"
        ></el-input>
      </el-form-item>
      <el-form-item label="Email Address">
        <el-input :disabled="true" v-model="studentParticular.email"></el-input>
      </el-form-item>
      <el-divider>Recommended By</el-divider>
      <p>Recommended by School Sponsoring Bodies or Incorporated Management Committees</p>
      <el-form-item label="Recommender's name">
        <el-input :disabled="true" v-model="studentParticular.recommendedSchoolBoard.recommenderName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Contact method">
        <el-input :disabled="true" v-model="studentParticular.recommendedSchoolBoard.recommenderContactMethod" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Relationship with the student">
        <el-input :disabled="true" v-model="studentParticular.recommendedSchoolBoard.relationshipWithTheStudent" placeholder=""></el-input>
      </el-form-item>

      <p>Recommended by Current Staff</p>
      <el-form-item label="Recommender's name">
        <el-input :disabled="true" v-model="studentParticular.recommendedCurrentStaff.recommenderName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Contact method">
        <el-input :disabled="true" v-model="studentParticular.recommendedCurrentStaff.recommenderContactMethod" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Relationship with the student">
        <el-input :disabled="true" v-model="studentParticular.recommendedCurrentStaff.relationshipWithTheStudent" placeholder=""></el-input>
      </el-form-item>

      <p>Recommended by Child of an Alumnus</p>
      <el-form-item label="Recommender's name">
        <el-input :disabled="true" v-model="studentParticular.recommendedChildAlumnus.recommenderName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Contact method">
        <el-input :disabled="true" v-model="studentParticular.recommendedChildAlumnus.recommenderContactMethod" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Last attended class">
        <el-input :disabled="true" v-model="studentParticular.recommendedChildAlumnus.recommenderLastAttendedClass" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Student ID">
        <el-input :disabled="true" v-model="studentParticular.recommendedChildAlumnus.recommenderStudentId" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Graduation year">
        <el-input :disabled="true" v-model="studentParticular.recommendedChildAlumnus.recommenderGraduationYear" placeholder=""></el-input>
      </el-form-item>

      <p>Recommended by Others</p>
      <el-form-item label="Recommender's name">
        <el-input :disabled="true" v-model="studentParticular.recommendedOthers.recommenderName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Contact method">
        <el-input :disabled="true" v-model="studentParticular.recommendedOthers.recommenderContactMethod" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Relationship with our school">
        <el-input :disabled="true" v-model="studentParticular.recommendedOthers.relationshipWithOurSchool" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="Relationship with the student">
        <el-input :disabled="true" v-model="studentParticular.recommendedOthers.relationshipWithTheStudent" placeholder=""></el-input>
      </el-form-item>

      <template v-if="studentParticular.siblingsIdentityDocument">
          <el-divider>More than one child is applying at Logos Academy</el-divider>
          <formTitle title="More than one child is applying at Logos Academy"></formTitle>
          <el-table :data="studentParticular.siblingsIdentityDocument.siblings" style="width: 100%;">
            <el-table-column prop="chineseName" label="Chinese Name" > </el-table-column>
            <el-table-column prop="englishName" label="English Name" > </el-table-column>
            <el-table-column prop="gender" label="Gender" >
              <template slot-scope="scope">
                <span>{{scope.row.gender == 0 ? 'Male' : 'Female'}}</span>
              </template>
            </el-table-column>
            <el-table-column  label="Birth Cert / Passport No.">
              <template slot-scope="scope">
                <span v-if="scope.row.certificateNo">{{scope.row.certificateNo}}</span>
                <span v-else>{{scope.row.passportNo}}</span>
              </template>
             </el-table-column>
          </el-table>
      </template>
      <personalBackground :isView="true" :personalBackground="personalBackground"></personalBackground>
      <studentPerformance v-if="type !== 0" :isView="true" :studentPerformance="studentPerformance"></studentPerformance>
      <el-divider>Information of Parents and Guardian</el-divider>
      <formTitle title="Information of Parents and Guardian"></formTitle>
      <el-table
        :data="parentParticularData.parentParticulars"
        style="width: 100%;"
      >
        <el-table-column  label="">
          <template slot-scope="{ row }">
                <el-checkbox :disabled="true" v-model="row.isMainGuardian"></el-checkbox>  
          </template>
        </el-table-column>
        <el-table-column prop="type" label="Identity">
          <template slot-scope="{ row }">
              <span>{{ row.type | identity }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="chineseName" label="Chinese Name">
        </el-table-column>
        <el-table-column prop="englishName" label="English Name">
        </el-table-column>
        <el-table-column prop="occupation" label="Occupation">
        </el-table-column>
        <el-table-column prop="officeTel" label="Mobile">
        </el-table-column>
        <el-table-column prop="organization" label="Organization">
        </el-table-column>
      </el-table>
      <el-divider>Declaration</el-divider>
      <el-radio-group v-model="declaration.isReadStatement">
        <el-radio disabled :label="true" class="wordWrap"
          >I have read and understood the above statement. I declare that to the
          best of my knowledge and belief the information given above is true
          and correct.
        </el-radio>
      </el-radio-group>
    </el-form>
  </div>
</template>

<script>
import applicationFormat from "@/utils/applicationFormat";
import moment from "moment";
import formTitle from "@/components/formTitle";
import studentPerformance from '@/components/studentPerformance'
import personalBackground from './personalBackground.vue'
export default {
  mixins:[applicationFormat],
  components: { formTitle,studentPerformance,personalBackground },
  props: {
    type: {
      type: Number,
      default: 0,
    },
    formLabelAlign: {
      type: Object,
      default: function () {},
    },
  },
  watch: {
    formLabelAlign: {
      handler(v, oldV) {
        if (v !== undefined && v !== null && oldV != undefined ) {
          
          this.$nextTick(() => {
          this.studentParticular = JSON.parse(
            this.componentMethods(v.components, 0)||'{}'
          );
          this.parentParticularData.parentParticulars = JSON.parse(
            this.componentMethods(v.components, 1)||'{}'
          );
          this.personalBackground = JSON.parse(
            this.componentMethods(v.components, 2)||'{}'
          );
          this.studentFiles = JSON.parse(
            this.componentMethods(v.components, 3)||'{}'
          );
          this.declaration = JSON.parse(this.componentMethods(v.components, 7)||'{}')
          this.studentPerformance = JSON.parse(
           this.componentMethods(v.components, 8)||'{}'
          );
        });
        }
      },
      deep: true,
      immediate:true
    },
  },
  computed: {
    addressEn() {
      return `${this.getHaveData(
        this.studentParticular.addressEn.flat
      )}${this.getHaveData(
        this.studentParticular.addressEn.floor
      )}${this.getHaveData(
        this.studentParticular.addressEn.block
      )}${this.getHaveData(
        this.studentParticular.addressEn.building
      )}${this.getHaveData(
        this.studentParticular.addressEn.village
      )}${this.getHaveData(
        this.studentParticular.addressEn.street
      )}${this.getHaveData(
        this.studentParticular.addressEn.district
      )}${this.getHaveData(this.studentParticular.addressEn.area)}`;
    },
    address() {
      return `${this.studentParticular.address.area}${this.studentParticular.address.district}${this.studentParticular.address.street}${this.studentParticular.address.village}${this.studentParticular.address.building}${this.studentParticular.address.block}${this.studentParticular.address.floor}${this.studentParticular.address.flat}`;
    },
    age() {
      return moment().diff(moment(this.studentParticular.dateOfBirth), "years")||'';
    },
    certificateNo(){
      return this.studentParticular?.certificateNoTop + this.studentParticular?.certificateNoCont + this.studentParticular?.certificateNoBottom
    },
    identityDocument() {
      return this.studentParticular.typeOfIdentityDocument?.type == 0
        ? this.getNewIdentityDocument(
            this.studentParticular.typeOfIdentityDocument?.certificateNo || this.certificateNo
          )
        : this.studentParticular.typeOfIdentityDocument?.passportNo;
    },
  },
  methods: {
    getNewIdentityDocument(value) {
      // console.log( this.studentParticular);
      let newValue = value.substr(value.length - 1, 1)||'';
      let basic = value.substr(0, value.length - 1) || '';
      return basic + `(${newValue})`;
    },
    getHaveData(value) {
      return value != "" ? value + "," : "";
    },
    componentMethods(components, type) {
      return components.filter((v) => {
        return v.type == type;
      })[0]?.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 20px;
}
.page-box-button {
  padding: 0 10px;
  text-align: right;
}
.text-details {
  min-height: 40px;
  padding: 10px;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #525252;
  cursor: not-allowed;
  border-radius: 5px;
  line-height: normal;
}
::v-deep{
  .el-divider__text{
    font-weight: bold;
    font-size: 18px;
  }
}
</style>